module.exports = __webpack_public_path__ + "3d7ff360dee630ac61c5bc061375fbcc.ttf";